import { IconButton } from "components/IconButton";

export const EpcBackButton = ({ onBack }: { onBack?: () => void }) => {
  if (!onBack) {
    return null;
  }
  return (
    <IconButton
      buttonProps={{ className: "ml-1 mt-1", onClick: onBack, size: "md", variant: "tertiary" }}
      iconProps={{ iconName: "ChevronLeft", size: "lg" }}
    />
  );
};
